/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit AppointmentTypes/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import React from 'react'
import TysiaCheckboxWithInputText from 'DesignSystem/TysiaCheckboxWithInputText/index'
import TysiaText from 'DesignSystem/TysiaText/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function AppointmentTypes({
  children,
  viewPath = "/App/Account/Content/Settings/Content/Leads/Content/Content/Settings/Content/AppointmentTypes",
  onChange
  
}) {
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
let settingsAppointmenttypesInpersonValueData = fromData.useDataValue({ viewPath,
context: 'settings',
path: 'appointmentTypes.inPerson',
})
let settingsAppointmenttypesInpersonChangeData = fromData.useDataChange({ viewPath,
context: 'settings',
path: 'appointmentTypes.inPerson',
})
let settingsAppointmenttypesVirtualValueData = fromData.useDataValue({ viewPath,
context: 'settings',
path: 'appointmentTypes.Virtual',
})
let settingsAppointmenttypesVirtualChangeData = fromData.useDataChange({ viewPath,
context: 'settings',
path: 'appointmentTypes.Virtual',
})
  return (<React.Fragment
>
<div
  data-testid="AppointmentTypes.Horizontal"
  data-view-path={viewPath}
 style={{'--g-1-1qdkjn': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--mb-2-1qdkjn': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs}}
 className={`views-block ${styles.Horizontal}`}
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 weight="medium"
 text="Appointment types allowed to be scheduled"
/>
<div
  data-testid="AppointmentTypes.Horizontal:1"
  data-view-path={viewPath}
 style={{'--g-1-1qdkjn': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS}}
 className={`views-block ${styles.Horizontal1}`}
>
<TysiaCheckboxWithInputText
  viewPath={`${viewPath}/TysiaCheckboxWithInputText`}
 size="small"
 data="settings.appointmentTypes.inPerson"
 value={settingsAppointmenttypesInpersonValueData}
 onChange={settingsAppointmenttypesInpersonChangeData}
 text="In Person"
/>
<TysiaCheckboxWithInputText
  viewPath={`${viewPath}/TysiaCheckboxWithInputText`}
 size="small"
 data="settings.appointmentTypes.Virtual"
 value={settingsAppointmenttypesVirtualValueData}
 onChange={settingsAppointmenttypesVirtualChangeData}
 text="Virtual"
/>
</div>
</div>
{children}
</React.Fragment>)
}